import AppController from 'controllers/app';

// Initialise Application
window.App = new AppController();